import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgentAuditDetailsResponse, AuditRecord } from '../../models/dashboard.model';
import { DashboardService } from '../../services/dashboard.service';
import { details } from '../../configs/agent-audit-details.config';
import { $Locale } from '@hubio/hubio-common-components';
import { CLICKABLE_AUDITS } from '../../configs/clickable-rows.config';

@Component({
  selector: 'app-broker-mail',
  templateUrl: './broker-mail.component.html',
  styleUrls: ['./broker-mail.component.scss']
})
export class BrokerMailComponent implements OnInit {

  public tseqno;
  public aid;
  public detailsItems;
  public brokerNumber;
  public data: AgentAuditDetailsResponse;
  public breadcrumbsSteps = [];

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private router: Router,
    public $Locale: $Locale
  ) {
  }

  ngOnInit(): void {
    this.tseqno = this.route.snapshot.params["tseqno"];
    this.aid = this.route.snapshot.params["aid"];
    this.dashboardService.getAgentAuditDetails({ aid: this.aid }).subscribe((data) => {
      this.data = data;
      this.breadcrumbsSteps.push({
        label: this.$Locale.get("files"),
        relativeRoute: "/communic8/"
      })
      if (!this.data.details || Object.keys(this.data.details).length == 0) {
        this.breadcrumbsSteps.push({
          label: this.tseqno,
          relativeRoute: this.router.url.split('/broker')[0]
        }, {
          label: this.aid,
          relativeRoute: this.router.url
        });
        return;
      };
      this.brokerNumber = this.data.details[details.brokerNumber];
      this.breadcrumbsSteps.push({
        label: this.data.details[details.fileName] as string,
        relativeRoute: this.router.url.split('/broker')[0]
      }, {
        label: this.brokerNumber,
        relativeRoute: this.router.url
      });
      this.detailsItems = [
        {
          label: "Broker Number",
          value: this.data.details[details.brokerNumber]
        },
        {
          label: "Number of Transactions",
          value: this.data.details[details.transactionCount]
        },
        {
          label: "Transactions in Error",
          value: this.data.details[details.errorCount]
        },
        {
          label: "CSIO Address",
          value: this.data.details[details.address]
        },
        {
          label: "Status",
          value: this.data.details[details.status]
        }
      ]
    });
  }

  navigateTransaction(record: AuditRecord) {
    const { aid, astatus } = record;
    if (!CLICKABLE_AUDITS[astatus]) return;
    this.router.navigateByUrl(`${this.router.url}/transaction/${aid}`);
  }
}
